<template>
	<div class="wrap">
		<div class="insidebanner">
			<img src="../assets/help/43489051_l.jpg" alt="">
			<span class="insidebanner-bor"></span>
		</div>
		<div class="content">
			<div class="content-faq">
				<div class="content-title">
					<h4>常见问题</h4>
					<img src="../assets/help/faq.png" alt="">
				</div>
				<!-- <transition-group name="flip-list" tag="ul" class="faq"> -->
					<ul class="faq">
						<li v-for="(item, index) in items" :key="index" @click="showAnswer(index)" :class="{active:index===activeIndex}">
							<div class="faq-q">
								<span>{{item.question}}</span>
								<i :class="index===activeIndex?'ico-open':'ico-close'"></i>
							</div>
							<div class="faq-a" v-if="activeIndex === index">
								<p v-html="item.answer"></p>
							</div>
						</li>
					</ul>
				<!-- </transition-group> -->
			</div>
			<div class="content-service">
				<div class="content-title">
					<h4>人工支持</h4>
					<img src="../assets/help/customer_service.png" alt="">
				</div>
				<div class="service">
					<img class="service-tel" src="../assets/help/3.png" alt="">
					<a class="service-online" href="javascript:;">咨询在线客服</a>
					<img class="service-pic" src="../assets/help/vector_smart_object.png" alt="">
				</div>
			</div>
			<div class="content-download">
				<div class="content-title">
					<h4>资料下载</h4>
					<img src="../assets/help/mannual_download.png" alt="">
				</div>
				<ul class="download">
					<li>
						<img src="../assets/help/garden.png" alt="">
						<a href="http://kafile.oss-cn-beijing.aliyuncs.com/website/KA%E5%84%BF%E7%AB%A5%E4%B9%8B%E5%AE%B6-%E6%9F%9A%E5%AD%90%E9%80%9A%E5%9B%AD%E6%89%80%E7%AB%AF%E4%BA%A7%E5%93%81%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E.pdf">《柚子通-园所端使用手册》</a>
					</li>
					<li>
						<img src="../assets/help/teacher.png" alt="">
						<a href="http://kafile.oss-cn-beijing.aliyuncs.com/website/KA%E5%84%BF%E7%AB%A5%E4%B9%8B%E5%AE%B6-%E6%9F%9A%E5%AD%90%E9%80%9A%E6%95%99%E5%B8%88%E7%AB%AF%E4%BA%A7%E5%93%81%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E.pdf">《柚子通-教师端使用手册》</a>
					</li>
					<li>
						<img src="../assets/help/parents.png" alt="">
						<a href="http://kafile.oss-cn-beijing.aliyuncs.com/website/KA%E5%84%BF%E7%AB%A5%E4%B9%8B%E5%AE%B6-%E6%9F%9A%E5%AD%90%E9%80%9A%E5%AE%B6%E9%95%BF%E7%AB%AF%E4%BA%A7%E5%93%81%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E.pdf">《柚子通-家长端使用手册》</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Help',
		data () {
			return {
				activeIndex: 0,
				items: [
					{question: 'Q:  开办园所需要哪些资质？', answer: '1)具备幼儿园的《办学许可证》、《卫生防疫证》、《幼儿园园舍租赁协议》或《房产证明》、《消防合格证》等相关各项合法的办学资质。<br>2)具备县级以上（包括县级）幼儿园开办标准。<br>3)具备必要的网络视频设备以达到网络视频会议培训的要求。<br>4)认同K.A的教育理念'},
					{question: 'Q:  KA的1-3-5-7模式是指什么？', answer: '1指的是一个平台：指的是我们KA幼教合伙人平台，因为在未来的发展规划上KA是以平台方式存在的，我们未来不单单输出伊顿的核心内容，也会通过伊顿的国际化资源来整合更多的符合国际化、品质化的内容一起以KA作为输出的唯一途径。<br>3指的是我们的教育理念，我们完全依照伊顿的3C教育理念（品格、多元文化、创造力）来对孩子进行塑造。<br>5指的是我们的核心优势，品牌的号召了， 教学教研能力，运营管理能力，线下示范园展示能力，信息技术开发能力。<br>7指的是目前我们提供的七大产品体系：品牌认证、运营管理、信息化系统、课程、增值课外课、家长大学及培训。'},
					{question: 'Q:  为什么选择KA？', answer: '1)伊顿16年的办学经验 <br>2)全国17个城市50所直营园所的运营管理经验 <br>3)国内外专家、具有国际认证资的教师及研发团队 <br>4)可做园所AMS认证，并且拥有实践基地 <br>5)国内高端连锁幼儿园品牌 <br>6)蒙氏教育本土化知名机构 <br>7)优秀的国际化课程、课外课程资源'},
					{question: 'Q:  合作方式是什么？', answer: '2种合作模式，一种是旗舰园，一种是品牌园    <br>收费标准：二种合作模式会在价格、量化服务次数上有区别'},
					{question: 'Q:  如何下载和开通柚子通？', answer: 'Apple Store、Android store自助下载，联系客服柚柚（微信号iaidushu2013）开通。'}
				]
			}
		},
		methods: {
			showAnswer: function(index) {
				this.activeIndex = index;
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../base/scss/mixin';
	.flip-list-move {
	  transition: transform .5s;
	}
	.content {
		background: url(../assets/partner/bg.jpg) center top repeat-y;
		&-faq {
			// min-height: 780px;
			padding-top: 64px;
			padding-bottom: 130px;
			background: url(../assets/help/faq_bg.jpg) center top no-repeat;
		}
		&-service {
			height: 510px - 68px;
			padding-top: 68px;
			background: #f6f6f6;
			margin-bottom: 60px;
		}
		&-download {
			margin-bottom: 80px;
			@extend %width;
		}
		&-title {
			margin-bottom: 50px;
			text-align: center;
			h4 {
				margin-bottom: 15px;
				font-weight: normal;
				font-size: 28px;
				color: #1d50a2;
			}
		}
	}
	.faq {
		width: 1036px;
		margin-left: auto;
		margin-right: auto;
		li {
			margin-bottom: 16px;
			font-size: 16px;
			cursor: default;
		}
		&-q {
			position: relative;
			line-height: 50px;
			padding-left: 50px;
			padding-right: 50px;
			background: #e7364b;
			color: #fff;
			i {
				position: absolute;
				right: 32px;
				top: 50%;
				margin-top: -9px;
				width: 18px;
				height: 18px;
			}
			.ico-open {
				background: url(../assets/help/dakai.png) left center no-repeat;
			}
			.ico-close {
				background: url(../assets/help/shouqi.png) left center no-repeat;
			}
		}
		&-a {
			
			// display: none;
			padding: 25px 50px;
			border-bottom: 1px solid #091338;
			p {
				line-height: 22px;
			}
		}
		.active {
			.faq-q{
				background: #091338;
			}
			.faq-a {
				// display: block;
			}
		}
	}
	.service {
		@extend %width;
		position: relative;
		padding-top: 126px - 50px;
		&-tel {
			display: block;
			margin-bottom: 40px;
			margin-left: 262px;
		}
		&-online {
			display: block;
			margin-left: 220px;
			width: 388px - 4px;
			@include lh(54px);
			border-radius: 10px;
			background: #e1e0e0;
			border: 2px solid #fff;
			font-size: 28px;
			color: #131313;
		}
		&-pic {
			position: absolute;
			height: 566px;
			right: 40px;
			top: -242px;
		}
	}
	.download {
		@extend %clearfix;
		padding: 26px 105px 0;
		li {
			float: left;
			margin: 0 50px;
			text-align: center;
		}
		&-cover {
			width: 174px;
			height: 174px;
			line-height: 174px;
			border: 1px solid #000;
			background: #fff;
			text-align: center;
			vertical-align: middle;
			margin-bottom: 24px;
		}
		a {
			display: block;
			padding-top: 40px;
			text-align: center;
			font-size: 16px;
			color: #1d50a2;
			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Help.vue